/*
 * Cart drawer upsell fallback.
 * snippets/upsell-redesign renders the cards in Liquid when the last cart item has
 * complementary products. This script only fills the row from /recommendations when
 * the server rendered nothing, and refreshes it after the drawer re-renders.
 * Prices from /recommendations are already in the shopper's currency.
 */
(() => {
  const trackSelector = '.cart-upsell-track';
  const templateId = 'cart-upsell-card';
  const blockedProductIds = [6906275758170, 6900568326234];
  let requestId = 0;

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format(
        cents / 100
      );
    } catch {
      return `${currency} ${(cents / 100).toFixed(2)}`;
    }
  };

  const makeCard = (product, template) => {
    const node = template.content.cloneNode(true);
    const image = node.querySelector('.upsell-image');
    const link = node.querySelector('.upsell-link');
    const title = node.querySelector('.upsell-title');
    const price = node.querySelector('.upsell-price');
    const button = node.querySelector('.related-atc-btn');
    if (image) {
      image.src = product.image;
      image.alt = product.title;
    }
    if (link) link.href = product.url;
    if (title) title.textContent = product.title;
    if (price) price.textContent = formatMoney(product.price);
    if (button) {
      button.dataset.productId = product.variant_id || '';
      button.setAttribute('aria-label', `Add ${product.title} to cart`);
    }
    return node;
  };

  const fetchRecommendations = async () => {
    const cart = await fetch(`${routes.cart_url}.js`).then((response) => response.json());
    if (!cart.items?.length) return [];
    const inCart = new Set(cart.items.map((item) => item.product_id));
    const lastProductId = cart.items.at(-1).product_id;
    const recommendations = await fetch(
      `${routes.product_recommendations_url}.json?product_id=${lastProductId}&limit=4`
    ).then((response) => response.json());
    return (recommendations.products || [])
      .filter((product) => product.available && !inCart.has(product.id) && !blockedProductIds.includes(product.id))
      .slice(0, 3)
      .map((product) => ({
        id: product.id,
        title: product.title,
        url: product.url,
        price: product.price,
        variant_id: product.variants?.find((variant) => variant.available)?.id || product.variants?.[0]?.id,
        image: product.featured_image
      }));
  };

  const fill = async () => {
    const track = document.querySelector(trackSelector);
    const template = document.getElementById(templateId);
    if (!track || !template || track.childElementCount > 0) return;
    const current = ++requestId;
    let products = [];
    try {
      products = await fetchRecommendations();
    } catch {
      return;
    }
    // A newer drawer render started while this was in flight
    if (current !== requestId || !track.isConnected || track.childElementCount > 0) return;
    const fragment = document.createDocumentFragment();
    products.forEach((product) => fragment.appendChild(makeCard(product, template)));
    track.replaceChildren(fragment);
  };

  const start = () => {
    fill();
    document.addEventListener('cart-drawer:rendered', fill);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
